import type { Category, Location } from '../../api/types';

export interface TreeNode {
  value: string;
  title: string;
  key: string;
  children: TreeNode[];
}

/** Dựng cây cho TreeSelect/Tree từ danh sách phẳng có parent_id. */
export function buildTree<T extends { id: string; parent_id: string | null; name: string }>(
  rows: T[],
): TreeNode[] {
  const node = (r: T): TreeNode => ({
    value: r.id,
    key: r.id,
    title: r.name,
    children: rows.filter((c) => c.parent_id === r.id).map(node),
  });
  return rows.filter((r) => !r.parent_id || !rows.some((x) => x.id === r.parent_id)).map(node);
}

export const categoryTree = (rows: Category[]) => buildTree(rows);
export const locationTree = (rows: Location[]) => buildTree(rows);
